import { Box, Container, Grid, Typography } from "@mui/material";
import { makeStyles } from "@mui/styles";
import MetaTags from "react-meta-tags";

import {
  UPLOADTARGETS_TITLE,
  UPLOADTARGETS_LINK_CANONICAL,
} from "helpers/metatags";

import NeedHelp from "components/upload/NeedHelp";
import { colors } from "theme";

import Requirements from "./components/Requirements";
import UploadTabs from "./components/UploadTabs";

const useStyles = makeStyles(() => ({
  container: {
    "& .MuiInputLabel-filled.Mui-focused": {
      color: colors.semantic.positive,
    },
    "& .MuiFilledInput-underline.Mui-focused:after": {
      borderColor: colors.semantic.positive,
    },
  },
}));

const UploadTargets = () => {
  const classes = useStyles();

  return (
    <Box display="flex" flexDirection="column" width={1}>
      <MetaTags>
        <title>{UPLOADTARGETS_TITLE}</title>
        <link rel="canonical" href={UPLOADTARGETS_LINK_CANONICAL} />
      </MetaTags>
      <Container>
        <Box pl={{ xs: 0, sm: 3 }} pr={{ xs: 0, sm: 3, md: 0 }} pt={5}>
          <Typography variant="h1">Provide Targets</Typography>
        </Box>
        <Box pl={{ xs: 0, sm: 3 }} pr={{ xs: 0, sm: 3, md: 0 }} pt={5} pb={7}>
          <Grid container spacing={6}>
            <Grid component="section" item md={8} className={classes.container}>
              <UploadTabs />
            </Grid>
            <Grid component="section" item md={4}>
              <Box mb={5}>
                <Requirements />
              </Box>
              <NeedHelp />
            </Grid>
          </Grid>
        </Box>
      </Container>
    </Box>
  );
};

export default UploadTargets;
